import { mock } from '@epicuro-next/state/user-state';

export const mockUserEntity = {
  userExternalId: '9fe665e2-61ce-4c72-8a4e-491344617029',
  user: mock,
  loading: false,
};
